var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "wrap" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _c(
        "div",
        { staticClass: "contents__contents contents__contents--overlap" },
        [
          _c("div", { staticClass: "result-detail" }, [
            _c("p", { staticClass: "result-detail__caption" }, [
              _vm._v("알쏭달쏭 단백질 퀴즈 정답 결과")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "result-detail__sum" }, [
              _c("div", [
                _c("p", [_vm._v("정답")]),
                _vm._v(" "),
                _c("span", { staticClass: "result-detail__flag" }, [
                  _vm._v(_vm._s(this.correct) + "개")
                ])
              ]),
              _vm._v(" "),
              _c("div", [
                _c("p", [_vm._v("오답")]),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "result-detail__flag result-detail__flag--secondary"
                  },
                  [_vm._v(_vm._s(this.incorrect) + "개")]
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "accordion" }, [
              _c(
                "button",
                {
                  staticClass: "accordion__header",
                  attrs: {
                    type: "button",
                    role: "heading",
                    id: "accoBtn01",
                    "aria-level": "3",
                    "aria-controls": "accoPanel01",
                    "aria-expanded": "true"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmMyAnswerResult("Q1")
                    }
                  }
                },
                [
                  _vm._m(1),
                  _vm._v(" "),
                  this.quizResult.Q1 === "X"
                    ? _c("span", { staticClass: "result-detail__flag" }, [
                        _vm._v("정답")
                      ])
                    : _c(
                        "span",
                        {
                          staticClass:
                            "result-detail__flag result-detail__flag--secondary"
                        },
                        [_vm._v("오답")]
                      ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "accordion__ico",
                    class: { "rotate-down": this.isOpen.Q1 },
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              this.isOpen.Q1
                ? _c(
                    "div",
                    {
                      staticClass: "accordion__panel",
                      attrs: {
                        role: "region",
                        id: "accoPanel01",
                        "aria-labelledby": "accoBtn01",
                        "aria-hidden": "true"
                      }
                    },
                    [
                      _c("div", { staticClass: "accordion__inner" }, [
                        this.quizResult.Q1 === "X"
                          ? _c("div", { staticClass: "result-detail__wrote" }, [
                              _vm._v("\n\t\t\t\t\t\t\t답:\n\t\t\t\t\t\t\t"),
                              _c("i", {
                                staticClass:
                                  "result-detail__shape result-detail__shape--x"
                              })
                            ])
                          : _c("div", { staticClass: "result-detail__wrote" }, [
                              _vm._v("\n\t\t\t\t\t\t\t답:\n\t\t\t\t\t\t\t"),
                              _c("i", {
                                staticClass:
                                  "result-detail__shape result-detail__shape--o"
                              }),
                              _vm._v(" "),
                              _vm._m(2)
                            ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "desc" }, [
                          _vm._v(
                            "\n\t\t\t\t\t\t\t단백질은 근육, 손톱, 머리카락 등 신체 조직을 구성하고 에너지를 합성하며, 세포 구축과 면역 시스템 강화, 호르몬, 효소 및 헤모글로빈 생성, 그리고 체내 화학 반응 등의 주요한 기능을 수행하는 데 필수적인 영양소로 우리 몸의 16% 를 차지하고 있습니다.  건강한 삶을 원한다면 단백질은 남녀노소 모두에게 필수인 영양소입니다.\n                        "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "etc" }, [
                          _vm._v(
                            "*출처: Hoffman, Jay R., and Michael J. Falvo. “Protein-which is best?.” Journal of sports science & medicine 3.3 (2004): 118.Duda, K., Majerczak, J., Nieckarz, Z., Heymsfield, S. B., & Zoladz, J. A. (2019). Human Body Composition and Muscle Mass. Muscle and Exercise Physiology, 3-26."
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "accordion__header",
                  attrs: {
                    type: "button",
                    role: "heading",
                    id: "accoBtn02",
                    "aria-level": "3",
                    "aria-controls": "accoPanel02",
                    "aria-expanded": "true"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmMyAnswerResult("Q2")
                    }
                  }
                },
                [
                  _vm._m(3),
                  _vm._v(" "),
                  this.quizResult.Q2 === "X"
                    ? _c("span", { staticClass: "result-detail__flag" }, [
                        _vm._v("정답")
                      ])
                    : _c(
                        "span",
                        {
                          staticClass:
                            "result-detail__flag result-detail__flag--secondary"
                        },
                        [_vm._v("오답")]
                      ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "accordion__ico",
                    class: { "rotate-down": this.isOpen.Q2 },
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              this.isOpen.Q2
                ? _c(
                    "div",
                    {
                      staticClass: "accordion__panel",
                      attrs: {
                        role: "region",
                        id: "accoPanel02",
                        "aria-labelledby": "accoBtn02",
                        "aria-hidden": "true"
                      }
                    },
                    [
                      _c("div", { staticClass: "accordion__inner" }, [
                        this.quizResult.Q2 === "X"
                          ? _c("div", { staticClass: "result-detail__wrote" }, [
                              _vm._v("\n\t\t\t\t\t\t답:\n\t\t\t\t\t\t"),
                              _c("i", {
                                staticClass:
                                  "result-detail__shape result-detail__shape--x"
                              })
                            ])
                          : _c("div", { staticClass: "result-detail__wrote" }, [
                              _vm._v("\n\t\t\t\t\t\t답:\n\t\t\t\t\t\t"),
                              _c("i", {
                                staticClass:
                                  "result-detail__shape result-detail__shape--o"
                              }),
                              _vm._v(" "),
                              _vm._m(4)
                            ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "desc" }, [
                          _vm._v(
                            "근육은 한번 합성을 시작하면 한번에 최대 30g의 단백질만을 사용합니다. 근육 합성 효율을 생각한다면 단백질 하루 권장 섭취량을 3시간 이상의 간격을 두고 균등하게 나누어 섭취하는 것이 좋습니다."
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "etc" }, [
                          _vm._v(
                            "*출처: Symons, T. Brock, et al. “A moderate serving of high-quality protein maximally stimulates skeletal muscle protein synthesis in young and elderly subjects.” J Am Diet Assoc 109.9 (2009): 1582-1586. Moore, Daniel R., et al. “Daytime pattern of post-exercise protein intake affects whole-body protein turnover in resistance-trained males.” Nutrition & metabolism 9.1 (2012): 1-5."
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "accordion__header",
                  attrs: {
                    type: "button",
                    role: "heading",
                    id: "accoBtn03",
                    "aria-level": "3",
                    "aria-controls": "accoPanel03",
                    "aria-expanded": "true"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmMyAnswerResult("Q3")
                    }
                  }
                },
                [
                  _vm._m(5),
                  _vm._v(" "),
                  this.quizResult.Q3 === "O"
                    ? _c("span", { staticClass: "result-detail__flag" }, [
                        _vm._v("정답")
                      ])
                    : _c(
                        "span",
                        {
                          staticClass:
                            "result-detail__flag result-detail__flag--secondary"
                        },
                        [_vm._v("오답")]
                      ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "accordion__ico",
                    class: { "rotate-down": this.isOpen.Q3 },
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              this.isOpen.Q3
                ? _c(
                    "div",
                    {
                      staticClass: "accordion__panel",
                      attrs: {
                        role: "region",
                        id: "accoPanel03",
                        "aria-labelledby": "accoBtn03",
                        "aria-hidden": "true"
                      }
                    },
                    [
                      _c("div", { staticClass: "accordion__inner" }, [
                        this.quizResult.Q3 === "O"
                          ? _c("div", { staticClass: "result-detail__wrote" }, [
                              _vm._v(
                                "\n                           답:\n\t\t\t\t\t\t\t"
                              ),
                              _c("i", {
                                staticClass:
                                  "result-detail__shape result-detail__shape--o"
                              })
                            ])
                          : _c("div", { staticClass: "result-detail__wrote" }, [
                              _vm._v(
                                "\n                           답:\n\t\t\t\t\t\t   "
                              ),
                              _c("i", {
                                staticClass:
                                  "result-detail__shape result-detail__shape--x"
                              }),
                              _vm._v(" "),
                              _vm._m(6)
                            ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "desc" }, [
                          _vm._v(
                            "체내 단백질은 나이가 들어감에 따라 자연스럽게 감소하여 65세 이상 노인의 경우 20대에 비해 총 신체 단백질이 약 14% 감소합니다. "
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "etc" }, [
                          _vm._v(
                            "*출처: Hardman, Shalene E. The Effects of Aging on Skeletal Muscle AMPK Activation and an Analysis of Chronic AICAR Treatment on the Aging Phenotype. Diss. Brigham Young University, 2014."
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "accordion__header",
                  attrs: {
                    type: "button",
                    role: "heading",
                    id: "accoBtn04",
                    "aria-level": "3",
                    "aria-controls": "accoPanel04",
                    "aria-expanded": "false"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmMyAnswerResult("Q4")
                    }
                  }
                },
                [
                  _vm._m(7),
                  _vm._v(" "),
                  this.quizResult.Q4 === "X"
                    ? _c("span", { staticClass: "result-detail__flag" }, [
                        _vm._v("정답")
                      ])
                    : _c(
                        "span",
                        {
                          staticClass:
                            "result-detail__flag result-detail__flag--secondary"
                        },
                        [_vm._v("오답")]
                      ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "accordion__ico",
                    class: { "rotate-down": this.isOpen.Q4 },
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              this.isOpen.Q4
                ? _c(
                    "div",
                    {
                      staticClass: "accordion__panel",
                      style: { display: this.isOpen.Q4 ? "block" : "none" },
                      attrs: {
                        role: "region",
                        id: "accoPanel04",
                        "aria-labelledby": "accoBtn04",
                        "aria-hidden": "true"
                      }
                    },
                    [
                      _c("div", { staticClass: "accordion__inner" }, [
                        this.quizResult.Q4 === "X"
                          ? _c("div", { staticClass: "result-detail__wrote" }, [
                              _vm._v(
                                "\n                           답:\n                           "
                              ),
                              _c("i", {
                                staticClass:
                                  "result-detail__shape result-detail__shape--x"
                              })
                            ])
                          : _c("div", { staticClass: "result-detail__wrote" }, [
                              _vm._v(
                                "\n                           답:\n\t\t\t\t\t\t   "
                              ),
                              _c("i", {
                                staticClass:
                                  "result-detail__shape result-detail__shape--o"
                              }),
                              _vm._v(" "),
                              _vm._m(8)
                            ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "desc" }, [
                          _vm._v(
                            "아닙니다. 근육 형성을 위해서는 운동과 함께 단백질 보충이 같이 이뤄져야합니다. 근육은 운동을 통해 근육에 자극을 주어 근섬유에 상처를 만들고, 이후 충분한 휴식과 영양 섭취를 통해 근섬유의 상처가 회복되는 과정에서 생성 됩니다. 효율적인 근육 생성을 위해 체중 1kg 당 1.5g의 단백질 섭취와 함께 주 3회 이상 근력 운동 꼭 기억해주세요!"
                          )
                        ]),
                        _vm._v(" "),
                        _c("p", { staticClass: "etc" }, [
                          _vm._v(
                            "*출처: Am J Physiol Endocrinol Metab. 2015 Jan 1;308(1):E21-8. Morton RW et al. A systematic review, meta-analysis and meta-regression of the effect of protein supplementation on resistance training-induced gains in muscle mass and strength in healthy adults. Br J Sports Med. 2018 Mar;52(6):376-384. Chargé SB, Rudnicki MA. Cellular and molecular regulation of muscle regeneration. Physiol Rev. 2004 Jan;84(1):209-38."
                          )
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "accordion__header",
                  attrs: {
                    type: "button",
                    role: "heading",
                    id: "accoBtn05",
                    "aria-level": "3",
                    "aria-controls": "accoPanel05",
                    "aria-expanded": "false"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmMyAnswerResult("Q5")
                    }
                  }
                },
                [
                  _vm._m(9),
                  _vm._v(" "),
                  this.Q5
                    ? _c("span", { staticClass: "result-detail__flag" }, [
                        _vm._v("정답")
                      ])
                    : _c(
                        "span",
                        {
                          staticClass:
                            "result-detail__flag result-detail__flag--secondary"
                        },
                        [_vm._v("오답")]
                      ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "accordion__ico",
                    class: { "rotate-down": this.isOpen.Q5 },
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              this.isOpen.Q5
                ? _c(
                    "div",
                    {
                      staticClass: "accordion__panel",
                      style: { display: this.isOpen.Q5 ? "block" : "none" },
                      attrs: {
                        role: "region",
                        id: "accoPanel05",
                        "aria-labelledby": "accoBtn05",
                        "aria-hidden": "true"
                      }
                    },
                    [
                      _c("div", { staticClass: "accordion__inner" }, [
                        this.Q5
                          ? _c("div", { staticClass: "result-detail__wrote" }, [
                              _vm._v(
                                "\n                           답:" +
                                  _vm._s(this.correctList.Q5[0]) +
                                  " 번 " +
                                  _vm._s(this.correctList.Q5[1]) +
                                  " 번 " +
                                  _vm._s(this.correctList.Q5[2]) +
                                  " 번\n                        "
                              )
                            ])
                          : _c(
                              "div",
                              { staticClass: "result-detail__wrote" },
                              [
                                _vm._v("\n\t\t\t\t\t\t\t답: \n\t\t\t\t\t\t\t"),
                                _vm._l(this.quizResult.Q5, function(i) {
                                  return _c(
                                    "span",
                                    { key: i, staticClass: "wrong-span" },
                                    [
                                      _vm._v(
                                        "\n\t\t\t\t\t\t\t\t" +
                                          _vm._s(i) +
                                          "번\n\t\t\t\t\t\t\t"
                                      )
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "result-detail__wrong" },
                                  [
                                    _vm._v(
                                      "\n\t\t\t\t\t\t\t   " +
                                        _vm._s(this.correctList.Q5[0]) +
                                        " 번 " +
                                        _vm._s(this.correctList.Q5[1]) +
                                        " 번 " +
                                        _vm._s(this.correctList.Q5[2]) +
                                        " 번 \n\t\t\t\t\t\t\t"
                                    )
                                  ]
                                )
                              ],
                              2
                            ),
                        _vm._v(" "),
                        _vm._m(10)
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "accordion__header",
                  attrs: {
                    type: "button",
                    role: "heading",
                    id: "accoBtn06",
                    "aria-level": "3",
                    "aria-controls": "accoPanel05",
                    "aria-expanded": "false"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmMyAnswerResult("Q6")
                    }
                  }
                },
                [
                  _vm._m(11),
                  _vm._v(" "),
                  this.quizResult.Q6 === "3"
                    ? _c("span", { staticClass: "result-detail__flag" }, [
                        _vm._v("정답")
                      ])
                    : _c(
                        "span",
                        {
                          staticClass:
                            "result-detail__flag result-detail__flag--secondary"
                        },
                        [_vm._v("오답")]
                      ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "accordion__ico",
                    class: { "rotate-down": this.isOpen.Q6 },
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion__panel",
                  style: { display: this.isOpen.Q6 ? "block" : "none" },
                  attrs: {
                    role: "region",
                    id: "accoPanel06",
                    "aria-labelledby": "accoBtn06",
                    "aria-hidden": "true"
                  }
                },
                [
                  _c("div", { staticClass: "accordion__inner" }, [
                    this.quizResult.Q6 === "3"
                      ? _c("div", { staticClass: "result-detail__wrote" }, [
                          _vm._v(
                            "\n                           답:" +
                              _vm._s(this.correctList.Q6) +
                              " 번\n                        "
                          )
                        ])
                      : _c("div", { staticClass: "result-detail__wrote" }, [
                          _vm._v("\n\t\t\t\t\t\t\t답: "),
                          _c("span", { staticClass: "wrong-span" }, [
                            _vm._v(_vm._s(this.quizResult.Q6))
                          ]),
                          _vm._v(" 번\n\t\t\t\t\t\t   "),
                          _c("div", { staticClass: "result-detail__wrong" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t   " +
                                _vm._s(this.correctList.Q6) +
                                " 번 \n\t\t\t\t\t\t\t"
                            )
                          ])
                        ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "체내 단백질 형성을 위해서는 총 20종의 아미노산이 필요합니다. 이 중 11종은 몸에서 합성되는 '비필수 아미노산'이며, 9종은 몸에서 합성되지 않아 식품으로 섭취해야 하는 '필수 아미노산' 입니다. 9가지 필수 아미노산이 모두 포함되어 있는 단백질을 완전 단백질이라고 하며, 단백질 제품을 선택 할 땐, 100% 완전 단백질인지 품질 기준을 확인하는 것이 매우 중요합니다."
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "etc" }, [
                      _vm._v(
                        "*출처: Scientific opinion on dietary reference values for protein. EFSA Journal 2012; 10(2):2557 Westerterp-Plantenga, M. S., Nieuwenhuizen, A., Tomé, D., Soenen, S., & Westerterp, K. R. (2009). Dietary Protein, Weight Loss, and Weight Maintenance. Annual Review of Nutrition, 29(1), 21–41."
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "accordion__header",
                  attrs: {
                    type: "button",
                    role: "heading",
                    id: "accoBtn05",
                    "aria-level": "3",
                    "aria-controls": "accoPanel04",
                    "aria-expanded": "false"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmMyAnswerResult("Q7")
                    }
                  }
                },
                [
                  _vm._m(12),
                  _vm._v(" "),
                  this.quizResult.Q7 === "2"
                    ? _c("span", { staticClass: "result-detail__flag" }, [
                        _vm._v("정답")
                      ])
                    : _c(
                        "span",
                        {
                          staticClass:
                            "result-detail__flag result-detail__flag--secondary"
                        },
                        [_vm._v("오답")]
                      ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "accordion__ico",
                    class: { "rotate-down": this.isOpen.Q7 },
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion__panel",
                  style: { display: this.isOpen.Q7 ? "block" : "none" },
                  attrs: {
                    role: "region",
                    id: "accoPanel05",
                    "aria-labelledby": "accoBtn05",
                    "aria-hidden": "true"
                  }
                },
                [
                  _c("div", { staticClass: "accordion__inner" }, [
                    this.quizResult.Q7 === "2"
                      ? _c("div", { staticClass: "result-detail__wrote" }, [
                          _vm._v(
                            "\n                           답:" +
                              _vm._s(this.correctList.Q7) +
                              " 번\n                        "
                          )
                        ])
                      : _c("div", { staticClass: "result-detail__wrote" }, [
                          _vm._v("\n\t\t\t\t\t\t\t답: "),
                          _c("span", { staticClass: "wrong-span" }, [
                            _vm._v(_vm._s(this.quizResult.Q7))
                          ]),
                          _vm._v(" 번\n\t\t\t\t\t\t   "),
                          _c("div", { staticClass: "result-detail__wrong" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t   " +
                                _vm._s(this.correctList.Q7) +
                                " 번 \n\t\t\t\t\t\t\t"
                            )
                          ])
                        ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "desc" }, [
                      _vm._v(
                        "단백질 섭취 골든타임은 기상직후/아침, 점심, 저녁, 운동 전/후 입니다. 특히 운동 직후 45분 이내 단백질을 섭취할 경우, 손상된 근육 단백질을 회복시키고 근육 내 글리코겐을 저장하여 근육 성장에 도움이 됩니다. 운동 후 잊지말고 단백질 꼭 챙겨주세요!"
                      )
                    ]),
                    _vm._v(" "),
                    _c("p", { staticClass: "etc" }, [
                      _vm._v(
                        '*출처 : Paddon-Jones D, Rasmussen BB. Dietary protein recommendations and the prevention of sarcopenia. Curr Opin Clin Nutr Metab Care. 2009 Jan;12(1):86-90. Schoenfeld, Brad Jon, et al. "Pre-versus post-exercise protein intake has similar effects on muscular adaptations." PeerJ 5 (2017): e2825. Ivy, J. L., & Ferguson-Stegall, L. M. (2013). Nutrient Timing. American Journal of Lifestyle Medicine, 8(4), 246–259.'
                      )
                    ])
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "accordion__header",
                  attrs: {
                    type: "button",
                    role: "heading",
                    id: "accoBtn05",
                    "aria-level": "3",
                    "aria-controls": "accoPanel04",
                    "aria-expanded": "false"
                  },
                  on: {
                    click: function($event) {
                      return _vm.confirmMyAnswerResult("Q8")
                    }
                  }
                },
                [
                  _vm._m(13),
                  _vm._v(" "),
                  this.quizResult.Q8 === "4"
                    ? _c("span", { staticClass: "result-detail__flag" }, [
                        _vm._v("정답")
                      ])
                    : _c(
                        "span",
                        {
                          staticClass:
                            "result-detail__flag result-detail__flag--secondary"
                        },
                        [_vm._v("오답")]
                      ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "accordion__ico",
                    class: { "rotate-down": this.isOpen.Q8 },
                    attrs: { "aria-hidden": "true" }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "accordion__panel",
                  style: { display: this.isOpen.Q8 ? "block" : "none" },
                  attrs: {
                    role: "region",
                    id: "accoPanel05",
                    "aria-labelledby": "accoBtn04",
                    "aria-hidden": "true"
                  }
                },
                [
                  _c("div", { staticClass: "accordion__inner" }, [
                    this.quizResult.Q8 === "4"
                      ? _c("div", { staticClass: "result-detail__wrote" }, [
                          _vm._v(
                            "\n                           답:" +
                              _vm._s(this.correctList.Q8) +
                              " 번\n                        "
                          )
                        ])
                      : _c("div", { staticClass: "result-detail__wrote" }, [
                          _vm._v("\n\t\t\t\t\t\t\t답: "),
                          _c("span", { staticClass: "wrong-span" }, [
                            _vm._v(_vm._s(this.quizResult.Q8))
                          ]),
                          _vm._v(" 번\n\t\t\t\t\t\t   "),
                          _c("div", { staticClass: "result-detail__wrong" }, [
                            _vm._v(
                              "\n\t\t\t\t\t\t\t   " +
                                _vm._s(this.correctList.Q8) +
                                " 번 \n\t\t\t\t\t\t\t"
                            )
                          ])
                        ]),
                    _vm._v(" "),
                    _vm._m(14),
                    _vm._v(" "),
                    _c("p", { staticClass: "etc" }, [
                      _vm._v(
                        '*출처:Hoffman, Jay R., and Michael J. Falvo. "Protein–which is best?." Journal of sports science & medicine 3.3 (2004): 118. Hashimoto A, Kambe T. Mg, Zn and Cu Transport Proteins: A Brief Overview from Physiological and Molecular Perspectives. J Nutr Sci Vitaminol (Tokyo). 2015;61 Suppl:S116-8. Reboul, E., & Borel, P. (2011). Proteins involved in uptake, intracellular transport and basolateral secretion of fat-soluble vitamins and carotenoids by mammalian enterocytes. Progress in lipid research, 50(4), 388–402.'
                      )
                    ])
                  ])
                ]
              )
            ])
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", { staticClass: "header" }, [
      _c("div", { staticClass: "header__container" }, [
        _c("div", { staticClass: "header__row" }, [
          _c("a", {
            staticClass: "prev prev--white",
            attrs: { href: "/myprotein-result", "aria-label": "이전" }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "accordion__title" }, [
      _c("em", [_vm._v("Q1.")]),
      _vm._v(
        "\n\t\t\t\t\t단백질은 운동하는 사람에게만 중요한 영양소이다?\n\t\t\t\t\t"
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "result-detail__wrong" }, [
      _c("i", { staticClass: "result-detail__shape result-detail__shape--x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "accordion__title" }, [
      _c("em", [_vm._v("Q2.")]),
      _vm._v(
        "\n                        단백질, 한번에 많이 먹을수록 좋다?\n                     "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "result-detail__wrong" }, [
      _c("i", { staticClass: "result-detail__shape result-detail__shape--x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "accordion__title" }, [
      _c("em", [_vm._v("Q3.")]),
      _vm._v(
        "\n                        나이가 들수록 체내 단백질이 자연스럽게 줄어든다?\n                     "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "result-detail__wrong" }, [
      _c("i", { staticClass: "result-detail__shape result-detail__shape--o" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "accordion__title" }, [
      _c("em", [_vm._v("Q4.")]),
      _vm._v(
        "\n                        운동만 열심히 하면 근육이 늘어난다?\n                     "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "result-detail__wrong" }, [
      _c("i", { staticClass: "result-detail__shape result-detail__shape--x" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "accordion__title" }, [
      _c("em", [_vm._v("Q5.")]),
      _vm._v(
        "\n                        다음 중 좋은 단백질 제품을 고르는 기준 으로 맞는 내용을 모두 골라주세요.\n                     "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "desc" }, [
      _vm._v("[좋은 단백질을 구매하는법] "),
      _c("br"),
      _vm._v(" ° 식약처 인증 건강기능식품 마크를 확인해요. "),
      _c("br"),
      _vm._v("° 아미노산 스코어가 100이상인 높은 영양가 제품을 선택해요. "),
      _c("br"),
      _vm._v("° 필수 및 비필수 아미노산 20가지가 모두 포함되었는지 확인해요. "),
      _c("br"),
      _vm._v(
        "° 합성착향료 없이 최소한의 원재료만으로 제대로 만든 제품을 선택해요."
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "accordion__title" }, [
      _c("em", [_vm._v("Q6.")]),
      _vm._v(
        "\n\t\t\t\t\t\t우리 몸에 반드시 필요한\n                        필수 및 비필수 아미노산은"
      ),
      _c("br"),
      _vm._v("\n                        총 ____ 종이다.\n                     ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "accordion__title" }, [
      _c("em", [_vm._v("Q7.")]),
      _vm._v("\n                        단백질 섭취 골든타임은"),
      _c("br"),
      _vm._v(
        "\n                        운동 직후 ____ 이내이다.\n                     "
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "accordion__title" }, [
      _c("em", [_vm._v("Q8.")]),
      _vm._v("\n                        다음 중 단백질의 공식 기능이"),
      _c("br"),
      _vm._v("\n\t\t\t\t\t\t아닌 것 은 무엇일까요?"),
      _c("br")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "desc" }, [
      _vm._v(
        "단백질은 신체 조직, 피부, 머리카락, 호르몬, 뼈, 효소  등 우리 몸을 구성하고 몸 곳곳에 비타민 및 무기질 등 영양소를 운반해 주고 저장함으로써 인체가 발달하고 성장하는 것을 도와주는 중요한 영양소입니다. 우리 몸 속 많은 역할을 하는 단백질, 왜 챙겨야 하는지 아시겠죠? "
      ),
      _c("br"),
      _vm._v(" [단백질 공식 기능] "),
      _c("br"),
      _vm._v(" ① 근육, 결합조직 등 신체조직의 구성성분 "),
      _c("br"),
      _vm._v(" ② 효소, 호르몬, 항체의 구성에 필요 "),
      _c("br"),
      _vm._v(" ③ 체내 필수 영양성분이나 활성물질의 운반과 저장에 필요 "),
      _c("br"),
      _vm._v(" ④ 체액, 산-염기의 균형 유지에 필요 "),
      _c("br"),
      _vm._v(" ⑤ 에너지, 포도당, 지질의 합성에 필요")
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26a2740c", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26a2740c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/myprotein-test/myproteinQuizAnswerResult.vue
// module id = null
// module chunks = 